import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { GlbStatusProvider } from './glbStatus.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GlbStatusProvider>
      <App />
    </GlbStatusProvider>
  </React.StrictMode>
);
